
import React from 'react';
import styles from './_dealer-dealer-group-member-editor.module.scss';
import { Window } from '@progress/kendo-react-dialogs';
import { WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Dealer, DealerDealerGroupInfo } from '../../../Models/Dealer';
import { GenericGrid, hasValue } from '@amsanalytics/react-shared-library';
import { useState } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { InputChangeEvent, RadioButton, RadioButtonChangeEvent } from '@progress/kendo-react-inputs';
import { Field, Form, FormElement, FormRenderProps } from '@progress/kendo-react-form';
import { FormInput } from '@amsanalytics/react-shared-library';

export interface DealerDealerGroupMemberEditorProps {
  onCancel: () => void;
  onSubmit: (dealerDealerGroup: DealerDealerGroupInfo) => void;
  dealerDealerGroupInfo: DealerDealerGroupInfo;
}

export default function DealerDealerGroupMemberEditor(props: DealerDealerGroupMemberEditorProps) {
  const [memberName, setMemberName] = useState<string>(props.dealerDealerGroupInfo.memberName);
  const [memberNumber, setMemberNumber] = useState<string>(props.dealerDealerGroupInfo.memberNumber);
  return (
    <div className={styles.dealerDealerGroupMemberEditorContainer}>
      <Window width={600} height={300} title={'Select Dealer(s)'} modal={true}>
        <Form
          initialValues={{memberName: props.dealerDealerGroupInfo.memberName, memberNumber: props.dealerDealerGroupInfo.memberNumber}}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement style={{ width: '100%' }}>
              <fieldset className={"k-form-fieldset"}>
                <legend className={"k-form-legend"} style={{ marginBottom: '0px' }} >
                  <span style={{ fontWeight: '500' }}>{'Dealer Information'}</span>
                </legend>
              </fieldset>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%' }}>
                  <Field
                    style={{ width: '100%' }}
                    fieldWrapperStyle={{ width: '100%', marginLeft: '0px' }}
                    formFieldWrapperStyle={{ width: '100%', marginLeft: '0px' }}
                    name="memberName"
                    id="memberName"
                    type="text"
                    label="Member Name *"
                    value={memberName}
                    onChange={(event: InputChangeEvent) => {
                      setMemberName(event.value);
                    }}
                    component={FormInput}
                    required={true}
                    validator={(value: any, valueGetter: (name: string) => any, fieldProps: { name: string }, required?: boolean) => {
                      return value?.length > 0 ? undefined : `Dealer Group Name is required`;;
                    }}
                  />
                  <Field
                    style={{ width: '100px' }}
                    fieldWrapperStyle={{ width: '100%', marginLeft: '0px' }}
                    formFieldWrapperStyle={{ width: '100%', marginLeft: '0px' }}
                    name="memberNumber"
                    id="memberNumber"
                    type="text"

                    onChange={(event: InputChangeEvent) => {
                      setMemberNumber(event.value);
                    }}
                    label="Member Number *"
                    value={memberNumber}
                    component={FormInput}
                    required={true}
                    validator={(value: any, valueGetter: (name: string) => any, fieldProps: { name: string }, required?: boolean) => {
                      return value?.length > 0 ? undefined : `Member Number is required`;;
                    }}
                  />
                </div>
              </div>
            </FormElement>
          )}
        />
        <WindowActionsBar layout={'stretched'}>
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
            onClick={() => { props.onCancel() }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
            disabled={!hasValue(memberName)}
            onClick={() => {              
                props.onSubmit({
                  dealerId: props.dealerDealerGroupInfo.dealerId,
                  dealerGroupId: props.dealerDealerGroupInfo.dealerGroupId,
                  memberName: memberName,
                  memberNumber: memberNumber
                } as DealerDealerGroupInfo);              
            }}
          >
            {'Submit'}
          </button>
        </WindowActionsBar>
      </Window>
    </div>
  );
}
